export default __webpack_public_path__ + "static/media/23.2411de64.jpg";